import React from 'react';
// import { Container, Row } from 'react-bootstrap';
// import { MenuBtn } from '../components/MenuBtn';
// import BuildImg from '../images/Home/hlz-BuildingB.jpg';
// import ContactImg from '../images/PageImg/contact-img.jpg';
// import { Link } from 'react-router-dom';
// import { Container, Row, Col } from 'react-bootstrap';
import './Home.css';

import homebg from '../images/PageImg/Home-page-bg.png'
import HeaderSlide from '../components/HeaderSlide'
import HlzSlide from '../components/HlzSlide'
import HlzBrief from '../components/HlzBrief'
import ProcessFlow from '../components/ProcessFlow'
import HlzTeams from '../components/HlzTeams'
import HlzWorks from '../components/HlzWorks'
import Footer from '../components/Footer'
import Copyrights from '../components/Copyrights'
import { GoTopBtn } from '../components/GoTopBtn';

// import ContactInfo from '../components/ContactInfo';
// import { CompanySlide } from '../components/CompanySlide'
// import { ProcessFlow } from '../components/ProcessFlow'
// import { HlzTeams } from '../components/HlzTeams'
// import { HlzWorks } from '../components/HlzWorks'
// import { Footer } from '../components/Footer';

export default function Home() {
  // console.log("into Home()");
  return (
    <div className='home-page'>
      <div className='homeheader'
        style={{ backgroundImage: `url(${homebg})`, height: "auto" }} >
        <HeaderSlide text={'HLZ Technology'} />
        <h4 className='text-light'>&nbsp;&nbsp;images/PageImg/Home-page-bg.png</h4>
      </div>
      {/* <br /> */}
      <div> <HlzSlide /> </div>
      <div> <HlzBrief /> </div>
      <div> <ProcessFlow /> </div>
      <div> <HlzTeams /> </div>
      <div> <HlzWorks /> </div>
      <div> <Footer /> </div>
      <div> <Copyrights /> </div>
      <div> <GoTopBtn /> </div>
    </div>
  )
}

// export default Home;